import Vue from 'vue'
import Router from 'vue-router'
import Login from "./pages/Login"
import PageNotFound from "./pages/PageNotFound"
import HomePage from "./pages/HomePage"
import Dashboard from "./pages/Dashboard"
import Sell from "./pages/Sell"
import Category from "./pages/Category"
import Products from "./pages/Products"
import PrintQrBarcode from "./pages/PrintQrBarcode"
import Invoices from "./pages/Invoices";
import Receipt from "./pages/Receipt";
import Reports from "./pages/Reports";
import store from "./store";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '*',
            name: 'PageNotFound',
            component: PageNotFound,
            meta: { requiresAuth: false, }
        },
        {
            path: '/',
            name: 'HomePage',
            component: HomePage,
            meta: { requiresAuth: false, }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: { requiresAuth: true, }
        },
        {
            path: '/sell',
            name: 'sell',
            component: Sell,
            meta: { requiresAuth: true, }
        },
        {
            path: '/category',
            name: 'category',
            component: Category,
            meta: { requiresAuth: true, }
        },
        {
            path: '/products',
            name: 'products',
            component: Products,
            meta: { requiresAuth: true, }
        },
        {
            path: '/print-qr-barcode',
            name: 'PrintQrBarcode',
            component: PrintQrBarcode,
            meta: { requiresAuth: true, }
        },
        {
            path: '/invoices',
            name: 'invoices',
            component: Invoices,
            meta: { requiresAuth: true, }
        },
        {
            path: '/receipt/:invoice',
            name: 'receipt',
            component: Receipt,
            meta: { requiresAuth: true, }
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            meta: { requiresAuth: true, }
        },
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const userData = store.get("userData");
    if (requiresAuth && !userData) {
        next("/login");
    } else {
        next();
    }
});

export default router
